import vSelect from 'vue-select'

export default vSelect
